import React from 'react';
import './InfoWrapper.css';

function InfoWrapper({ children }: React.PropsWithChildren<object>): React.ReactNode {
  return <div className="info-wrapper">{children}</div>;
}

export default InfoWrapper;
